import { Th } from "@chakra-ui/react";

export function ThActions() {
  return <Th aria-label="Options" w="45px"></Th>;
}
